import { logger } from "./../../../api/Logger.js";

export default {
  state: {
    logList: []
  },
  mutations: {
    setlogData(state, payload) {
      state.logList = payload;
    }
  },
  actions: {
    initLoggerData({ commit }) {
      let data = logger.getLogData();
      commit("setlogData", data);
    },
    clearLog({ commit }) {
      logger.clearLog();
      commit("setlogData", []);
    },
    // eslint-disable-next-line no-empty-pattern
    insertErrorlog({}, value) {
      logger.log(value[0], value[1], value[2], logger.LogType.Error);
    },
    // eslint-disable-next-line no-empty-pattern
    insertWarninglog({}, value) {
      logger.log(value[0], value[1], value[2], logger.LogType.Warning);
    },
    // eslint-disable-next-line no-empty-pattern
    redirectToErrorPage({}) {
      // router.replace("/GeneralError");
    }
  },
  getter: {
    getCurrentLogData({ state }) {
      return state.logList;
    }
  }
};
